import { render, staticRenderFns } from "./ParamSituacaoTributaria.vue?vue&type=template&id=1ec434fb"
import script from "./ParamSituacaoTributaria.vue?vue&type=script&lang=js"
export * from "./ParamSituacaoTributaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports